import  { componentAttributeTypes, attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import WebDesigner from "../WebDesigner";


export default class BusinessLogo extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessLogo;
        this.displayName = "Business Logo";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation];     
        this.editList = [...this.primaryEditAttributes, componentAttributeTypes.multiLocation,attributeTypes.height,attributeTypes.width];   
        this.resizeType = ResizeableType.All;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" fill="currentColor" className="bi bi-briefcase" viewBox="0 0 16 16">  <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5m1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0M1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5"/></svg>
        this.hideAdvancedSettings = true;       
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, "");
        const atts = GetNodeDomAttributes("vb-control business-logo", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="logo" layout={layout} classNames={atts.className} />
        }
        return (
            <Fragment>
                <div {...atts}>
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="logo" node={component} userContext={siteData} />
                </div>
            </Fragment>
        )
    }
}
